<template>
    <div class="img_source w710">
        <draggable
                class="perview_img"
                tag="ul"
                v-model="attachmentList"
                @start="isDragging=true"
                @end="draggEndSort"
        >
            <transition-group type="transition" :name="'flip-list'">
                <li v-for="(attachment,index) in attachmentList" :key="index">
                    <img :src="attachment.url" alt/>
                    <i class="el-icon-circle-close delupload" @click="deletefile(index)"></i>
                </li>
            </transition-group>
        </draggable>
        <el-upload
                class="addicon"
                ref="imgupload"
                :data="uploaddata"
                :action="uploadurl"
                accept="image/jpeg,image/png"
                :on-success="handleSuccess"
                :on-error="handleError"
                :show-file-list="false"
                :before-upload="beforeUpload"
                :on-exceed="handleExceed"
                :file-list="fileList"
                multiple
                :limit="defaultlimit"
        >
            <i class="el-icon-plus avatar-uploader-icon"></i>
            <div slot="tip" class="el-upload__tip">
                <slot name="tipinfo"></slot>
            </div>
        </el-upload>
    </div>
</template>
<script>
    import api from "@/api.js";
    import draggable from "vuedraggable";
    import {mapState} from "vuex";

    export default {
        components: {
            draggable
        },
        /*

          picture:初始传始的值
          limit:数量限制
        */
        props: ["picture", "limit"],
        data() {
            return {
                editable: true,
                isDragging: false,
                delayedDragging: false,
                uploadurl: api.uploadTokenImg,
                uploaddata: {token: sessionStorage.getItem("token")},
                defaultlimit: parseInt(this.limit) || 1,
                fileList: this.picture || [],
                attachmentList: this.picture || []
            };
        },
        watch: {
            isDragging(newValue) {
                if (newValue) {
                    this.delayedDragging = true;
                    return;
                }
                this.$nextTick(() => {
                    this.delayedDragging = false;
                });
            },
            picture(val) {
                this.attachmentList = this.initfilelist(val);
            }
        },
        created() {
            this.attachmentList = this.initfilelist(this.attachmentList);
        },
        methods: {
            draggEndSort() {
                this.uploadsucess();
                this.isDragging = false;
            },
            // 初始化重组图像列表数据
            initfilelist(files) {
                let filelist = [];
                files.forEach((item, index) => {
                    filelist.push({
                        url: item
                    });
                });
                return filelist;
            },
            // 上传成功
            handleSuccess(res, file) {
                if (res.code === 0) {
                    this.attachmentList.push({
                        url: res.path
                    });
                    this.uploadsucess();
                } else {
                    this.$message.error(res.msg);
                }
                this.loadingStatus.close();
            },
            uploadsucess() {
                const res = [];
                this.attachmentList.forEach(item => {
                    res.push(item.url);
                });
                this.$emit("uploadsucess", res);
            },
            // 获取重取图像列表数据
            getattachment(path) {
                let filelist = [];
                filelist.push();
                return filelist;
            },

            // 删除图像组件缓存数据
            deletefile(index) {
                this.attachmentList.splice(index, 1);
                this.fileList = this.attachmentList;
                this.uploadsucess();
            },
            handleError(err, file) {
                this.$message({
                    type: "error",
                    message: "上传失败"
                });
            },
            beforeUpload(file) {
                const isJPG = file.type === "image/jpeg" || file.type === "image/png";
                const isLt2M = file.size / 1024 / 1024 < 10;
                let status = true;
                if (!isJPG) {
                    this.$message.error("上传图片只能是 JPG或者PNG 格式!");
                    status = false
                }
                if (!isLt2M) {
                    this.$message.error("上传图片大小不能超过 10MB!");
                    status = false
                }
                if(status){
                  this.loadingStatus = this.$loading({
                    lock: true,
                    text: '上传中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.4)',
                    customClass: 'fontColor'
                  });
                }

                return isJPG && isLt2M;
            },

            handleExceed(files) {
                this.$message.warning(
                    `当前限制选择 ${this.defaultlimit}个文件，本次选择了 ${
                        files.length
                    } 个文件，共选择了 ${files.length + this.attachmentList.length} 个文件`
                );
            }
        }
    };
</script>

